import { jsx } from "react/jsx-runtime";
import { WeeklyDatePicker } from "@wix/wix-ui-tpa/cssVars";
import { useMemo } from "react";
import { useConfig } from "../../../../contexts/config-context.js";
import { useTranslation } from "../../../../contexts/translation-context.js";
import { getFirstDayOfTheWeek } from "../../../../date-localization/get-first-day-of-the-week.js";
import { isSameDay } from "../../utils/format-timezone.js";
import { classes } from "./datepicker.st.css";
import { Indicators } from "./indicators/index.js";
const isAvailable = (date, availableDates) => {
  return availableDates.some(
    (slot) => isSameDay(new Date(slot.slot?.startDate), date)
  );
};
const renderIndication = ({
  date,
  isSelected,
  availableDates,
  isReloadingSlots
}) => {
  if (!isReloadingSlots && !isSelected && isAvailable(date, availableDates)) {
    return /* @__PURE__ */ jsx(Indicators, {});
  }
  return null;
};
const DatePicker = ({
  availableDates,
  selectedDate,
  onDateChange,
  disabled,
  onWeekChange
}) => {
  const { language } = useConfig();
  const { t } = useTranslation();
  const firstDayOfWeek = useMemo(
    () => getFirstDayOfTheWeek(language),
    [language]
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classes.root,
      onBlur: (e) => {
        e.stopPropagation();
        e.preventDefault();
      },
      children: /* @__PURE__ */ jsx(
        WeeklyDatePicker,
        {
          className: classes.datepicker,
          leftArrowAriaLabel: t(
            "form.appointment.accessibility.calendar.previous-week.aria-label"
          ),
          rightArrowAriaLabel: t(
            "form.appointment.accessibility.calendar.next-week.aria-label"
          ),
          value: selectedDate,
          onChange: (date) => onDateChange && !disabled && selectedDate && !isSameDay(new Date(date), selectedDate) && onDateChange(new Date(date)),
          excludePastDates: true,
          firstDayOfWeek,
          removeOuterPadding: true,
          onDisplayedWeekChange: ({ startOfWeek, endOfWeek }) => onWeekChange && onWeekChange(startOfWeek, endOfWeek),
          filterDate: (date) => !(disabled && selectedDate && !isSameDay(date, selectedDate)),
          locale: language,
          dateIndication: ({ date, isSelected }) => renderIndication({
            date,
            isSelected,
            availableDates,
            isReloadingSlots: disabled
          })
        }
      )
    }
  );
};
export {
  DatePicker
};
//# sourceMappingURL=datepicker-wut.js.map
